var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gift/solid",
    clipPath: "url(#clip0_152_2701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_152_2701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.59375 2.74998C8.13791 2.74998 7.70074 2.93106 7.37841 3.25339C7.05608 3.57572 6.875 4.01289 6.875 4.46873C6.875 4.92457 7.05608 5.36174 7.37841 5.68407C7.70074 6.0064 8.13791 6.18748 8.59375 6.18748H10.3125V10.3125H3.09375C2.63791 10.3125 2.20074 10.1314 1.87841 9.80907C1.55608 9.48674 1.375 9.04957 1.375 8.59373V7.90623C1.375 6.95656 2.145 6.18748 3.09375 6.18748H6.02067C5.57499 5.52542 5.40241 4.71675 5.53899 3.93043C5.67556 3.14412 6.11072 2.441 6.75353 1.968C7.39635 1.495 8.19709 1.28871 8.98844 1.39224C9.77978 1.49577 10.5005 1.90111 11 2.52356C11.4995 1.90111 12.2202 1.49577 13.0116 1.39224C13.8029 1.28871 14.6036 1.495 15.2465 1.968C15.8893 2.441 16.3244 3.14412 16.461 3.93043C16.5976 4.71675 16.425 5.52542 15.9793 6.18748H19.5938C20.5425 6.18748 21.3125 6.95748 21.3125 7.90623V8.59373C21.3125 9.5434 20.5425 10.3125 19.5938 10.3125H11.6875V6.18748H13.4063C13.7462 6.18748 14.0785 6.08668 14.3611 5.89782C14.6438 5.70896 14.8641 5.44053 14.9942 5.12647C15.1243 4.81241 15.1583 4.46682 15.092 4.13342C15.0257 3.80001 14.862 3.49376 14.6216 3.25339C14.3812 3.01302 14.075 2.84932 13.7416 2.783C13.4082 2.71669 13.0626 2.75072 12.7485 2.88081C12.4345 3.0109 12.166 3.2312 11.9772 3.51384C11.7883 3.79649 11.6875 4.12879 11.6875 4.46873V6.18748H10.3125V4.46873C10.3125 3.51906 9.5425 2.74998 8.59375 2.74998ZM10.3125 11.6875H2.75V17.875C2.75 18.422 2.9673 18.9466 3.35409 19.3334C3.74089 19.7202 4.26549 19.9375 4.8125 19.9375H10.3125V11.6875ZM11.6875 11.6875V19.9375H17.875C18.422 19.9375 18.9466 19.7202 19.3334 19.3334C19.7202 18.9466 19.9375 18.422 19.9375 17.875V11.6875H11.6875Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_152_2701",
    x: -0.25463,
    y: -0.263541,
    width: 23.1968,
    height: 21.8306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.814815
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.123548 0 0 0 0 0.442501 0 0 0 0 0.914551 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_152_2701"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_152_2701",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_2701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEvent);
export default __webpack_public_path__ + "static/media/icon-event.bc32d67c019f830c97e5fc26585122fa.svg";
export { ForwardRef as ReactComponent };